
import ComponentAbstract from './ComponentAbstract';
import { autobind } from 'frontools/decorators/Autobind';
import GameAbstract from '../GameAbstract';
import { Assets } from '../Assets';

export default class GameTimer extends ComponentAbstract {

    private _time               : number                    = 3;
    private _current            : number                    = 1;
    private _timeout            : number;
    private _timer              : PIXI.Container            = new PIXI.Container();
    private _sTimer             : PIXI.Sprite               = Assets.sprites['gameTimer'];
    private _sMask              : PIXI.Sprite               = Assets.sprites['gameTimerMask'];
    private _milk               : PIXI.Graphics             = new PIXI.Graphics();
    private _milkHeight         : number;
    private _isRunning          : boolean                   = false;

    public static COMPLETE      : string                = 'complete';
    public static TIME_CHANGE    : string                = 'onTimeChange';

    constructor(time: number) {
        super();

        this._time = time;
        
        this._sMask.x = 22;
        this._sMask.y = 21;
        this._sMask.visible = false;

        let bg = new PIXI.Graphics;
        bg.beginFill(0x00bce7);
        bg.drawCircle(this._sTimer.width / 2, this._sTimer.height / 2, this._sTimer.width / 2 - 4);
        bg.endFill();
        this._timer.addChild(bg);
        
        this._timer.addChild(this._sMask, bg, this._milk, this._sTimer);
        this._timer.pivot.x = this._timer.width / 2;
        this._timer.pivot.y = this._timer.height / 2;
        this._pixi.stage.addChild(this._timer);
        
        this._milk.beginFill(0xffffff);
        this._milk.drawRect(this._sMask.x, this._sMask.y + this._sMask.height, this._sMask.width, this._sMask.height);
        this._milk.endFill();
        this._milk.pivot.y = this._sMask.height + this._sMask.y;
        this._milk.y = 21;
        // this._milk.x = 50;        
    };

    /*
     * _count - Iterates through the countdown
     * @param {Object} data - game data
     * 
     */
    private _count() {
        if(!this._isRunning) return;

        if (this._time >= this._current) {
            var timeLeft = this._time - this._current,
                percent = this._current / this._time;
                
            if (timeLeft === 4) {
                Assets.sounds['running_out'].play();
            }
            TweenMax.to(this._milk.position, 1, {y: this._sMask.position.y + this._sMask.height * percent, ease: Linear.easeNone});
            TweenMax.to(this._milk.scale, 1, {y: 1 - percent, ease: Linear.easeNone, onComplete: this._count.bind(this)});
            this._current++;

            // dispatch
            this.dispatch({type: GameTimer.TIME_CHANGE, timeLeft: timeLeft + 1, progress: percent});
        } else {            
            this._onEnded();
        }
    };


    /*
     * _start - starts the timer
     * 
     */
    public start() {
        this._isRunning = true;
        this._count();
    };

    
    /*
     * _start - starts the timer
     * 
     */
    public stop() {
        this._isRunning = false;
        TweenMax.killTweensOf(this._milk);
        this._onEnded();
    };


    /*
     * _pause - pause the timer
     * 
     */
    private _onEnded() {
        this._isRunning = false;
        this.dispatch({type: GameTimer.TIME_CHANGE, timeLeft: 0});
        this.dispatch({type: GameTimer.COMPLETE});
        this.destroy();
    };


    /*
     * _getTime - pause the timer
     * 
     */
    public get timeLeft(): number {
        return this._time - this._current;
    };
    
    
    /*
     * _getTime - pause the timer
     * 
     */
    public get time(): number {
        return this._time;
    };


    /*
     * GET component - returns component HTML ELement
     * 
     */
    public get el(): PIXI.Container { return this._timer; }
    

    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        TweenMax.killTweensOf(this._milk);
        super.destroy();
    };



    /*
     * _resize - handle resize
     * 
     */
    protected _resize(e) {
        super._resize(e);

        this._timer.y = this._timer.height / 2 + 20;
        this._timer.x = this._pixi.screen.width - this._timer.width / 2 - 20;
    };

}